var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"width":"300","show-modal":_vm.showModal,"styleContent":{ minWidth: '80%' }},on:{"close-modal":function($event){return _vm.$emit('close-modal')}}},[_c('div',{staticClass:"w-full"},[_c('ViewShipments',{attrs:{"selecetedActionShipment":_vm.selecetedActionShipment}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }